var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    viewBox: "0 0 60 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 60c-.4 0-.8-.2-1.1-.4-.4-.4-.5-.9-.4-1.4l4.5-17.5c.1-.3.2-.5.4-.7L41.7 3.2c2-2 4.7-3.2 7.6-3.2 2.9.1 5.6 1.1 7.6 3.1S60 7.9 60 10.7s-1.2 5.6-3.2 7.6L20 55.1c-.2.2-.4.3-.7.4L1.9 60h-.4zm5.8-18.2L3.5 56.5l14.7-3.8 36.5-36.5c1.5-1.4 2.3-3.4 2.3-5.5s-.8-4.1-2.3-5.5-3.4-2.4-5.5-2.3c-2.1 0-4.1.9-5.5 2.3L7.3 41.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7 19.8c-.4 0-.8-.1-1.1-.4l-13-13c-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0l13 13c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4zM19 55.5c-.4 0-.8-.1-1-.4l-13-13c-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0l13 13c.6.6.6 1.5 0 2.1-.3.3-.7.4-1.1.4z"
  })));
};
export default SvgEdit;